import PropTypes from 'prop-types';

export const ImageSimpleComponent = (props) => {
    const {srcUrl, height, width, borderRadius} = props;
    return (
        <div
            style={{
                backgroundImage: `url(${srcUrl})`,
                width: width + 'px',
                height: height + 'px',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: borderRadius + '%',
                marginBottom: '-12px',
                marginTop: '-12px',
            }}
        />
    );
};

ImageSimpleComponent.defaultProps = {};

ImageSimpleComponent.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
    borderRadius: PropTypes.number,
    srcUrl: PropTypes.string.isRequired,
};

export default ImageSimpleComponent;
